import userService from '@/api/User';
import {defineStore} from 'pinia'

interface User {
    roles?: string[];

    [key: string]: any;
}

interface CurrentUser {
    token: string;
    user: User | null;
    impersonating: boolean;
    isCoordinator: boolean
}

export const piniaUserStore = defineStore('currentUser', {
    state: (): { currentUser: CurrentUser } => ({
        currentUser: {
            token: '',
            user: null,
            impersonating: false,
            isCoordinator: false
        },
    }),

    actions: {
        async piniaGetUser() {
            try {
                const {data} = await userService.current();
                this.currentUser.user = data.data.user
                this.currentUser.impersonating = data.data.impersonating
                this.currentUser.isCoordinator = data.data.isCoordinator
            } catch (err) {
                // await ErrorToast(err);
            }
        },
    }
})